export default {
  "*.legendItem.legendItem": function legendItemLegendItem() {
    return {
      "icon.appearing": function iconAppearing() {
        return [{
          initialAttr: {
            opacity: 0
          },
          slot: 'plot',
          startEnd: {
            start: .5,
            end: 1
          },
          finalAttr: {
            opacity: 1
          }
        }];
      },
      "background.appearing": function backgroundAppearing(a) {
        return [{
          initialAttr: {
            opacity: 0
          },
          slot: 'plot',
          startEnd: {
            start: .5,
            end: 1
          },
          finalAttr: {
            opacity: a.attr.opacity
          }
        }];
      },
      "icon.disappearing": function iconDisappearing() {
        return [{
          finalAttr: {
            opacity: 0
          },
          slot: 'initial'
        }];
      }
    };
  }
};